//统一管理用户相关的接口
import request from "@/utils/request";
//统一接口管理
let API = {
  captchaImage_URl:"/captchaImage",
  LOGIN_URL: "/login",
  USERINFO_URL: "/getInfo",
  LOGOUT_URL: "/logout",
  REGISTER_URL: "/register",
  SMS_LOGIN_URL: "/v1/sms/login",
  SMS_UPDATE_URL: "/v1/sms/update",
  PHONE_LOGIN_URL: "/v1/user/phoneLogin",
  RESET_PWD_URL: "/v1/user/resetPassword",
};
//暴露请求函数
//获取验证码图片
export const reqImage = () => request.get(API.captchaImage_URl);
//暴露接口方法
export const reqLogin = (data) => request.post(API.LOGIN_URL, data);
//获取用户信息接口方法
export const reqUserInfo = () => request.get(API.USERINFO_URL);
//退出登录
export const reqLogOut = () => request.post(API.LOGOUT_URL);
export const registerUser = (user) => request.post(API.REGISTER_URL, user);

// 发送登录短信验证码
export const reqSendSmsLogin = (phone) => request.get(API.SMS_LOGIN_URL, { params: { phone } });
// 发送重置密码短信验证码
export const reqSendSmsUpdate = (phone) => request.get(API.SMS_UPDATE_URL, { params: { phone } });
// 短信验证码登录
export const reqPhoneLogin = (data) => request.post(API.PHONE_LOGIN_URL, data);
// 忘记密码-重置密码
export const reqResetPwd = (data) => request.post(API.RESET_PWD_URL, data);